<template>
  <div
    v-if="config && config.visible"
    class="editor-wrapper"
  >
    <v-overlay
      :value="showLoader"
      class="d-flex align-center justify-center"
      opacity="0.2"
      persistent
    >
      <v-progress-circular
        indeterminate
        size="60"
        color="primary"
      />
    </v-overlay>

    <div
      class="main-div"
    >
      <html-editor
        v-model="formDataComputed.html"
        :init="init"
      />
    </div>
  </div>
</template>

<script>
import HtmlEditor from '@/global/components/html-editor/HtmlEditor.vue'
export default {
  name: 'DocumentPreview',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formDataComputed: {},
      init: {}
    }
  },

  components: {
    HtmlEditor
  },

  computed: {
    showLoader () {
      return !!this.config?.showLoader
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          this.formDataComputed = val
        }
      }
    },

    'config.content': {
      immediate: true,
      deep: true,
      handler (val) {
        this.$set(this.formDataComputed, 'html', val?.html || '')
        this.$set(this.init, 'content_style', val?.css || '')
      }
    }
  }
}
</script>

<style scoped>
.main-div {
  padding: 5px;
  border-radius: 16px;
  border: 1px solid #E5E7EB;
  margin: 15px;
  font-family: 'Satoshi', sans-serif !important;
  display: flex;
  flex-grow: 1;
}

.editor-wrapper {
  display: flex;
  flex-grow: 1;
}
</style>
